import {CommonResponse, BaseRequestParams, instance} from "./API"
import {AxiosResponse} from "axios"
import {LoginResponse, UserResponse} from "../models/response"

export const authApi = {
    login(form: LoginForm): Promise<CommonResponse<LoginResponse>> {
        const {controller, ...rest} = form
        return instance.post(`auth/login`, {...rest}, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    logout(params: BaseRequestParams): Promise<CommonResponse<LoginResponse>> {
        const {controller} = params
        return instance.get(`auth/logout`, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    checkAuth(params: BaseRequestParams): Promise<CommonResponse<UserResponse>> {
        const {controller} = params
        return instance.get(`auth/checkAuth`, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
}

export type LoginForm = {
    email: string
    password: string
    pushToken: string
    device: string
    isRemaining: boolean
} & BaseRequestParams